'use client'

import { formatRate } from '@polaris/core/utils'
import { useAtomValue } from 'jotai'
import {
  amountOutUSDAtom,
  priceImpactAtom,
  routeErrorsAtom,
} from '@/src/stores/swap/atoms'

export const AmountOutUSDLabel = () => {
  const amountOut = useAtomValue(amountOutUSDAtom)
  const priceImpact = useAtomValue(priceImpactAtom)
  const routeErrors = useAtomValue(routeErrorsAtom)

  return (
    <div>
      {amountOut !== null ? (
        <p className='text-secondary text-sm leading-6'>
          {amountOut} &nbsp;
          {routeErrors?.priceImpactHigh && priceImpact && (
            <span
              className={routeErrors.priceImpactHigh ? 'text-danger-text' : ''}
            >
              ({formatRate(priceImpact)})
            </span>
          )}
        </p>
      ) : null}
    </div>
  )
}
